module.exports = __webpack_public_path__ + "static/media/paperclip.ec655e89.svg";